import { useCallback } from 'react';
import { useSearchParams } from 'react-router';
import useRouter from '~/hooks/useRouter';
import { useSnackbar } from '~/providers/SnackbarProvider';
import useDataLayer from '~/services/datalayer';

export default function useSampleDownload(
  uuid: string | undefined,
  searchName: string | undefined,
  total: number | undefined
) {
  const { openSnackbar } = useSnackbar();
  const router = useRouter();
  const [searchParams] = useSearchParams();
  const dataLayer = useDataLayer();

  return useCallback(() => {
    const url = `${
      import.meta.env.VITE_API_URL
    }/downloads-sample?search=${uuid}&${searchParams.toString()}`;
    if (!window.open(url)) {
      window.alert(
        'Your browser may have blocked a popup from downloading the sample report.'
      );
    }
    dataLayer.push({
      event: 'sample download',
      type: 'search',
      query: searchName,
      total: total || 0,
      uuid: uuid,
    });

    openSnackbar('Sample report downloaded');
    router.push({
      path: '/pricing',
      query: {
        reason: 'downloads.sample',
        search: uuid,
      },
    });
  }, [uuid, searchName, total, searchParams, router, openSnackbar, dataLayer]);
}
